import PropTypes from "prop-types";
import submit from "submit-form";
import Dropdown from "../dropdown";
import DropdownFocus from "../dropdown-focus";
import { truncateText } from "../../utils/string-helpers";
/**
 * * options is an array like this: 
 * [
    {
      text:'',
      value:...
    },
    {
      text:'',
      value:...
    },
    ...
 * ]
 */
function Select(
  {
    name,
    options,
    onChange,
    title,
    value,
    disabled,
    withFocus = false,
    withTruncate = false,
  },
  { locals: { query } }
) {
  const summaryText =
    (options?.length > 0 &&
      (options.find((item) => value === item.value)?.text ||
        options.find((item) => value === item.value)?.label)) ||
    value ||
    "";

  const commonProps = {
    options,
    summaryText: withTruncate ? truncateText(summaryText, 12) : summaryText,
    onSelectFn: (newVal) => {
      if (onChange) return onChange(newVal);

      submit(`/actions/refresh`, {
        method: "GET",
        body: { [name]: newVal },
      });
    },
    disabled,
  };

  return (
    <>
      {title && <label>{title}</label>}
      <input
        type="hidden"
        name={name}
        value={value}
        onChange={(e) => undefined}
      />
      {withFocus ? (
        <DropdownFocus {...commonProps} />
      ) : (
        <Dropdown {...commonProps} />
      )}
    </>
  );
}

Select.contextTypes = { locals: PropTypes.object };

export default Select;
